import { render } from "./FixedDatesCalendarStrip.vue?vue&type=template&id=5f08c6c4&scoped=true"
import script from "./FixedDatesCalendarStrip.vue?vue&type=script&lang=js"
export * from "./FixedDatesCalendarStrip.vue?vue&type=script&lang=js"

import "./FixedDatesCalendarStrip.vue?vue&type=style&index=0&id=5f08c6c4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f08c6c4"]])

export default __exports__